import { playTones } from "../../../utils/audioContext";

// The bell chime, kept audibly distinct from the chat chime so the two never get confused.
//
// Chat is a quick rising fourth on a sine wave (A5 -> D6, see
// pages/Chat/utils/notificationSound.js). This is the same interval inverted — a falling fourth,
// E5 -> B4 — on a triangle wave, which is lower, hollower and a touch slower. Same family by
// design, opposite direction in practice: rising and bright means someone messaged you, falling
// and mellow means something in the system needs you.
const BELL_NOTES = [
    { freq: 659.25, start: 0, duration: 0.14 },  // E5
    { freq: 493.88, start: 0.13, duration: 0.26 }, // B4
];

// CRITICAL repeats the motif once instead of changing it, so an urgent alert is recognisably
// the same sound rather than a third one to learn.
const BELL_NOTES_URGENT = [
    ...BELL_NOTES,
    { freq: 659.25, start: 0.42, duration: 0.14 },
    { freq: 493.88, start: 0.55, duration: 0.3 },
];

/**
 * @param {string} [level] a NOTIFICATION_LEVELS value; only CRITICAL changes the sound
 */
const playNotificationSound = (level) => {
    const urgent = level === 'CRITICAL';
    playTones(urgent ? BELL_NOTES_URGENT : BELL_NOTES, { type: 'triangle', volume: urgent ? 0.24 : 0.18 });
}

export default playNotificationSound;
